export default "__VITE_ASSET__B5zh36Ta__"